import { defineStore } from "pinia";

export const useJobChannelsStore = defineStore('jobChannelsModule', {
    state: () => ({
        types: [
            {
                label: 'general.other',
                value: 'other',
            },
            {
                label: 'applications.sharejob.jobboards',
                value: 'jobboard',
            },
        ],
        urlTypes: [
            {
                label: 'jobchannels.url_types.detail.label',
                value: 'detail',
                info: 'jobchannels.url_types.detail.info'
            },
            {
                label: 'jobchannels.url_types.form.label',
                value: 'form',
                info: 'jobchannels.url_types.form.info'
            },
        ]
    })
});
